/* ============================================================
   GO FAST — Shopify Export main.js
   Minimal: navbar scroll + mobile menu + product page basics
   ============================================================ */
(function () {
  'use strict';

  /* ── Navbar scroll class ── */
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── Mobile menu ── */
  const hamburger  = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileMenu.classList.toggle('open', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('open');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ── Newsletter form ── */
  const nlForm    = document.getElementById('newsletterForm');
  const nlSuccess = document.getElementById('newsletterSuccess');
  if (nlForm && nlSuccess) {
    nlForm.addEventListener('submit', e => {
      e.preventDefault();
      nlForm.style.display = 'none';
      nlSuccess.hidden = false;
      setTimeout(() => { nlForm.reset(); nlForm.style.display = ''; nlSuccess.hidden = true; }, 5000);
    });
  }

  /* ── Product page: thumbnail switching ── */
  const thumbs   = document.querySelectorAll('.gallery__thumb');
  const mainImg  = document.getElementById('galleryMain');

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-pressed','false'); });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');
      if (mainImg) {
        const bg = thumb.querySelector('div')?.style.background;
        if (bg) mainImg.style.background = bg;
      }
    });
  });

  /* ── Product page: colour swatches ── */
  document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('.color-swatches');
      group.querySelectorAll('.swatch').forEach(s => { s.classList.remove('active'); s.setAttribute('aria-pressed','false'); });
      swatch.classList.add('active');
      swatch.setAttribute('aria-pressed', 'true');
      const nameEl = document.getElementById('selectedColorName');
      if (nameEl) nameEl.textContent = swatch.dataset.color || '';
    });
  });

  /* ── Product page: size selection ── */
  let selectedSize = null;
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      document.querySelectorAll('.size-btn').forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed','false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      selectedSize = btn.dataset.size;
      const el = document.getElementById('selectedSize');
      if (el) el.textContent = selectedSize;
    });
  });

  /* ── Product page: add to cart (demo) ── */
  const addBtn = document.getElementById('addToCartBtn');
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (!selectedSize) {
        const grid = document.getElementById('sizeGrid');
        if (grid) { grid.style.outline = '1.5px solid var(--copper)'; setTimeout(() => grid.style.outline = '', 1200); }
        return;
      }
      addBtn.textContent = 'Added to Bag ✓';
      addBtn.style.background = '#7AACB8';
      addBtn.style.borderColor = '#7AACB8';
      const count = document.querySelector('.cart-count');
      if (count) count.textContent = (parseInt(count.textContent) || 0) + 1;
      setTimeout(() => {
        addBtn.textContent = 'Add to Cart';
        addBtn.style.background = '';
        addBtn.style.borderColor = '';
      }, 2000);
    });
  }

  /* ── Size guide modal ── */
  const sizeGuideBtn  = document.getElementById('sizeGuideBtn');
  const sizeModal     = document.getElementById('sizeModal');
  const sizeModalClose = document.getElementById('sizeModalClose');

  if (sizeGuideBtn && sizeModal) {
    sizeGuideBtn.addEventListener('click', () => { sizeModal.hidden = false; });
    sizeModalClose?.addEventListener('click', () => { sizeModal.hidden = true; });
    sizeModal.addEventListener('click', e => { if (e.target === sizeModal) sizeModal.hidden = true; });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') sizeModal.hidden = true; });
  }

  /* ── Wishlist toggle (visual only) ── */
  const wishlistBtn = document.getElementById('wishlistBtn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', () => {
      const active = wishlistBtn.getAttribute('aria-pressed') === 'true';
      wishlistBtn.setAttribute('aria-pressed', !active);
      const path = wishlistBtn.querySelector('path');
      if (path) {
        path.setAttribute('fill',   active ? 'none' : '#C9967A');
        path.setAttribute('stroke', active ? 'currentColor' : '#C9967A');
      }
    });
  }

})();
